import { getRefundAdminStage } from "../../../../../data/flight/order/getRefundAdminGuidance";
import PricingBreakdown, { PricingStatusBanner } from "./PricingBreakdown";

function PricingSectionQuoteReady({ data }) {
  const expired = getRefundAdminStage(data) === "quote_expired";

  return (
    <div className="w-full border h-fit border-gray-200 rounded-xl overflow-hidden bg-white mt-4 p-4">
      <div className="flex items-center justify-between mb-4 gap-2">
        <h2 className="text-lg font-bold text-gray-900">Refund</h2>
        <PricingStatusBanner data={data} />
      </div>
      <p
        className={`text-xs mb-3 ${
          expired ? "text-red-700 font-medium" : "text-gray-500"
        }`}
      >
        {expired
          ? "This quote has expired. Enter a new quote from the airline — do not submit on these figures."
          : "The agent must accept this quote before you submit it to the airline."}
      </p>
      <div className="bg-primary1/5 p-4 text-sm text-gray-700">
        <PricingBreakdown data={data} />
      </div>
    </div>
  );
}

export default PricingSectionQuoteReady;
